let buttonsShow = document.querySelectorAll('.js-button-show');
let buttonsHide = document.querySelectorAll('.js-button-hide');

buttonsShow.forEach((e, index) => {
    let showContent = e.parentElement.parentElement.parentElement.nextElementSibling;
    e.addEventListener('click', (i) => {
        showContent.classList.toggle('active');
        e.classList.toggle('active');

        if (showContent.classList.contains('active')) {
            e.textContent = 'Ukryj szczegóły';
        } else {
            e.textContent = 'Pokaż szczegóły';
        }
    })

    buttonsHide.forEach((elem) => {
        elem.addEventListener('click', (btn) => {
            if (showContent.classList.contains('active')) {
                showContent.classList.toggle('active');
                e.textContent = 'Pokaż szczegóły';
                e.classList.toggle('active');
            }
        })
    })
})

